/**
 * Google Recaptcha wrapper
 * this component will work together with react-validations
 * remember to add the following script before the view's js
 * <script src="https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit"
 */

// deps
import PropTypes from 'prop-types';
// import Reaptcha from 'reaptcha';
import Recaptcha from 'react-google-invisible-recaptcha';

export default class CustomRecaptcha extends React.Component {
    static propTypes = {
        wrapperClassName: PropTypes.string,
    };

    static defaultProps = {
        wrapperClassName: ''
    };

    constructor() {
        super();

        this.state = {
            validated: false
        };
        this.onResolved = this.onResolved.bind( this );
    }

    onResolved = () => {
        this.setState({validated: true});
        this.recaptcha.execute();
        // Process Data //
        console.log('this.state validated..: ', this.state);
    };

    _onChangeHandler = (validated) => this.setState({ validated })

    render() {
        return (
            <div className={`recaptcha-wrapper ${this.props.wrapperClassName}`}>
{/* Default Google Sitekey: 6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI
Development Sitekey: 6LcjXoMbAAAAACbntzqpHDw9gR-j8RV4QFrv5VbI
Production Sitekey: 6LcjXoMbAAAAAH05VmKKT0UgjFATRe7LAHxtNl9C
*/}
                {/* <Reaptcha
                  ref={e => (this.captcha = e)}
                  sitekey="6LcjXoMbAAAAACbntzqpHDw9gR-j8RV4QFrv5VbI"
                  onVerify={ () => this._onChangeHandler(true) }
                  onExpire={ () => this._onChangeHandler(false) }
                /> */}
                <Recaptcha
                    ref={e => (this.captcha = e)}
                    sitekey="6LcjXoMbAAAAAH05VmKKT0UgjFATRe7LAHxtNl9C"
                    onResolved={ this.onResolved }
                />

                {/* <input
                    type="checkbox"
                    name="google-recaptcha"
                    className="hide"
                    checked={ this.state.validated }
                    value={ this.state.validated }
                    required
                /> */}
            </div>
        );
    }
}
